module.exports = __webpack_public_path__ + "img/benitier-cagot-h900.b1a81a4a.jpg";